import { Text, Tooltip } from "@chakra-ui/react";
import { formatDate } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import type { TimeTrackingReportItemFragment } from "@src/__generated__/graphql";
import { useStore as useStores } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

type TimeBillingStatusType = "invoiced" | "overserviced" | "uninvoiced";

type TimeBillingStatusTooltipProps = {
  readonly type: TimeBillingStatusType;
  readonly item: TimeTrackingReportItemFragment;
};

export const TimeBillingStatusTooltip = observer(
  function TimeBillingStatusTooltip({
    type,
    item,
  }: TimeBillingStatusTooltipProps) {
    const { workspaceStore } = useStores();
    const sourceAmount =
      type === "invoiced"
        ? item.invoiced_seconds
        : type === "overserviced"
          ? item.overserviced_seconds
          : item.uninvoiced_seconds;

    // Show dash if no seconds for this status type
    if (!sourceAmount || sourceAmount === 0) {
      return <Text>-</Text>;
    }

    const amount =
      workspaceStore.settings?.convertTimeTrackingRate(sourceAmount);

    return (
      <Tooltip
        label={
          <Text fontSize="xs">
            <Trans>Date:</Trans>&nbsp;
            {formatDate(new Date(item.tracked_for_date))}
            <br />
            <Trans>Hours:</Trans>&nbsp;{amount}
            <br />
            <Trans>Project:</Trans>&nbsp;
            {item.project_time_billing_project_name}
            <br />
            <Trans>User:</Trans>&nbsp;
            {item.user_full_name ?? <Trans>Work Expense</Trans>}
            <br />
            <Trans>Time billing:</Trans>&nbsp;{item.project_time_billing_name}
          </Text>
        }
      >
        <Text cursor="help">{amount}</Text>
      </Tooltip>
    );
  },
);
